/* Glamorush Free Delivery Nudge - safe, no prototype overrides */
(function(){
  try{
    var FREE = 300000; /* PKR 3000 in paisa */
    var MAX_PILLS = 4;

    /* ---- Update nudge bar when variant price changes ---- */
    function updateNudge(priceInPaisa){
      try{
        var wrap = document.getElementById('gr-nudge-wrap');
        if(!wrap) return;
        var fill = document.getElementById('gr-nudge-fill');
        var truck = document.getElementById('gr-nudge-truck');
        var amtEl = document.getElementById('gr-nudge-amt');
        if(!fill||!truck||!amtEl) return;
        var price = priceInPaisa || parseInt(wrap.dataset.price||'0',10);
        var needed = FREE - price;
        var pct = Math.min(Math.round((price/FREE)*100),100);
        fill.style.width = pct+'%';
        truck.style.left = pct+'%';
        if(needed > 0){
          var pkr = Math.ceil(needed/100);
          amtEl.textContent = 'PKR '+pkr.toLocaleString();
        } else {
          /* Product qualifies — swap bar for success message */
          var bw = wrap.querySelector('.gr-nudge__bar-wrap');
          if(bw){
            bw.outerHTML = '<div class="gr-nudge__unlocked"><span class="gr-nudge__tick">&#10003;</span><span>This product qualifies for <strong>FREE delivery!</strong></span></div>';
          }
        }
      }catch(e){}
    }

    /* ---- Load suggested products from same collections ---- */
    function loadSuggestions(){
      try{
        var pillsEl = document.getElementById('gr-nudge-pills');
        if(!pillsEl) return;
        var wrap = document.getElementById('gr-nudge-wrap');
        if(!wrap) return;
        var price = parseInt(wrap.dataset.price||'0',10);
        var needed = FREE - price;
        if(needed <= 0){ return; }

        /* Fetch collection products via Shopify Ajax API */
        fetch('/collections/all/products.json?limit=12&sort_by=price-ascending')
          .then(function(r){ return r.json(); })
          .then(function(data){
            try{
              var products = (data.products||[]).filter(function(p){
                /* Show products that help reach free shipping threshold */
                var pPrice = p.variants[0].price*100;
                return pPrice > 0 && pPrice !== price;
              }).slice(0,MAX_PILLS);

              pillsEl.innerHTML = '';
              if(products.length === 0){
                var sg = document.getElementById('gr-nudge-suggest');
                if(sg) sg.style.display='none';
                return;
              }

              products.forEach(function(p){
                try{
                  var imgSrc = p.images[0] ? p.images[0].src.replace('.jpg','_60x60.jpg').replace('.png','_60x60.png').replace('.webp','_60x60.webp') : '';
                  var pPrice = Math.round(p.variants[0].price);
                  var pill = document.createElement('a');
                  pill.className = 'gr-nudge__pill';
                  pill.href = '/products/'+p.handle;
                  pill.title = 'Add '+p.title;
                  pill.innerHTML =
                    (imgSrc ? '<img src="'+imgSrc+'" alt="'+p.title+'" loading="lazy">' : '')+
                    '<span>'+p.title.substring(0,22)+(p.title.length>22?'...':'')+'</span>'+
                    '<span class="gr-nudge__pill-price">PKR '+pPrice.toLocaleString()+'</span>'+
                    '<span class="gr-nudge__pill-add" title="Add to cart">+</span>';

                  /* Add to cart on + button click */
                  pill.querySelector('.gr-nudge__pill-add').addEventListener('click',function(e){
                    try{
                      e.preventDefault();
                      e.stopPropagation();
                      var addBtn = this;
                      addBtn.textContent = '...';
                      fetch('/cart/add.js',{
                        method:'POST',
                        headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
                        body:JSON.stringify({id:p.variants[0].id,quantity:1})
                      }).then(function(r){
                        if(r.ok){
                          addBtn.textContent = '&#10003;';
                          addBtn.style.background='#27ae60';
                          /* Open mini cart if available */
                          var mc = document.querySelector('.js-drawer-open-cart,[data-drawer-open="cart-drawer"],#CartCount,.header__icon--cart');
                          if(mc) mc.click();
                        } else {
                          addBtn.textContent = '+';
                        }
                      }).catch(function(){
                        addBtn.textContent = '+';
                      });
                    }catch(ex){}
                  });

                  pillsEl.appendChild(pill);
                }catch(ex){}
              });
            }catch(ex){}
          }).catch(function(){});
      }catch(e){}
    }

    /* ---- Listen for variant changes from theme ---- */
    function listenVariantChange(){
      try{
        /* Method 1: theme fires custom event on variant change */
        document.addEventListener('variant:changed',function(e){
          try{
            if(e.detail && e.detail.variant){
              updateNudge(e.detail.variant.price*100);
            }
          }catch(ex){}
        });

        /* Method 2: watch the hidden select for changes */
        var sel = document.querySelector('select[name="id"]');
        if(sel){
          sel.addEventListener('change',function(){
            try{
              var opt = sel.options[sel.selectedIndex];
              if(opt){
                /* price not in select, re-read from page JSON */
                var json = document.querySelector('.pr_variants_json');
                if(json){
                  var variants = JSON.parse(json.textContent||'[]');
                  var v = variants.find(function(vv){ return String(vv.id)===opt.value; });
                  if(v) updateNudge(v.price);
                }
              }
            }catch(ex){}
          });
        }
      }catch(e){}
    }

    /* ---- INIT ---- */
    function init(){
      try{
        var wrap = document.getElementById('gr-nudge-wrap');
        if(!wrap) return;
        updateNudge();
        loadSuggestions();
        listenVariantChange();
      }catch(e){}
    }

    if(document.readyState==='loading'){
      document.addEventListener('DOMContentLoaded',init);
    } else {
      init();
    }
  }catch(e){}
}());
